import { FetchClientResponse } from './types';

export const normalizeClient = (
  client: FetchClientResponse
): FetchClientResponse => ({
  ...client,
  MobilePhoneNumber: `${client.MobilePhonePrefix}${client.MobilePhoneNumber}`,
});
